// src/store/sagas.js
import { all, fork } from "redux-saga/effects"

// Sirf authentication related sagas rakho (baaki sab delete)
import AccountSaga from "./auth/register/saga" // Register
import AuthSaga from "./auth/login/saga" // Login
import ForgetSaga from "./auth/forgetpwd/saga" // Forget Password
import ProfileSaga from "./auth/profile/saga" // Profile edit/fetch

// Agar koi aur custom saga chahiye (jaise notification, report fetch), to baad mein yahan add kar sakte ho

export default function* rootSaga() {
  yield all([
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    // baaki sab delete kar do – yeh lines hata do
  ])
}
